module.exports = __webpack_public_path__ + "img/cd.ed47822b.svg";